import { render, staticRenderFns } from "./batch-extension-search.vue?vue&type=template&id=cf564cd2"
import script from "./batch-extension-search.vue?vue&type=script&lang=js"
export * from "./batch-extension-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports